import * as zod from 'zod';

import { TCPOffsetOption } from '@sb/motion-planning';
import { Expression } from '@sb/routine-runner/types';

export default zod.object({
  targetSpaceItemId: zod.string(),
  targetKind: zod.enum(['space', 'workpiece']),
  action: zod.enum(['show', 'hide']),
  palletizing: zod
    .object({
      scope: zod.enum(['allBoxes', 'allBoxesInLayer', 'specificBox']),
      opacity: zod.boolean(),
      labels: zod.boolean(),
      layerIndex: Expression.optional(),
      boxIndex: Expression.optional(),
      boxTypeID: zod.string().optional(),
      palletBaseID: zod.string().optional(),
    })
    .optional(),
  positionList: zod
    .object({
      positionScope: zod.enum(['allPositions', 'specificPosition']),
      positionIndex: Expression.optional(),
    })
    .optional(),
  workpiece: zod
    .object({
      visualizationType: zod.enum(['tooltip', 'pickup']),
      tooltipOption: TCPOffsetOption.optional(),
    })
    .optional(),
});
